var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrganization(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "corporate_fare_black_24dp") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Roles-and-Permissions",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "09-Create-Org-Menu-Mobile",
    transform: "translate(-22.000000, -192.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(-1.000000, 78.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-3",
    transform: "translate(0.000000, 104.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "corporate_fare_black_24dp",
    transform: "translate(23.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,8.16666667 L14,3.5 L2.33333333,3.5 L2.33333333,24.5 L25.6666667,24.5 L25.6666667,8.16666667 L14,8.16666667 Z M11.6666667,22.1666667 L4.66666667,22.1666667 L4.66666667,19.8333333 L11.6666667,19.8333333 L11.6666667,22.1666667 Z M11.6666667,17.5 L4.66666667,17.5 L4.66666667,15.1666667 L11.6666667,15.1666667 L11.6666667,17.5 Z M11.6666667,12.8333333 L4.66666667,12.8333333 L4.66666667,10.5 L11.6666667,10.5 L11.6666667,12.8333333 Z M11.6666667,8.16666667 L4.66666667,8.16666667 L4.66666667,5.83333333 L11.6666667,5.83333333 L11.6666667,8.16666667 Z M23.3333333,22.1666667 L14,22.1666667 L14,10.5 L23.3333333,10.5 L23.3333333,22.1666667 Z M21,12.8333333 L16.3333333,12.8333333 L16.3333333,15.1666667 L21,15.1666667 L21,12.8333333 Z M21,17.5 L16.3333333,17.5 L16.3333333,19.8333333 L21,19.8333333 L21,17.5 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganization);
export default __webpack_public_path__ + "static/media/organization.b96484a11a3cc56cd724b7ffee3ff8f5.svg";
export { ForwardRef as ReactComponent };